module.exports = __webpack_public_path__ + "static/media/EXPORT_BULK_UPLOAD_ATHENA_WITH_VAT_PARTNER.bae14756.xlsx";